import {Pipe, PipeTransform} from '@angular/core';
import {FormService} from '../shared/form.service';

@Pipe({
  name: 'selectedPlan',
  pure: false
})
export class SelectedPlanPipe implements PipeTransform {
  constructor(public formService: FormService) {
  }

  transform(value: any, currentForm: any, ...args: unknown[]): unknown {
    let plan = null;
    if (value) {
      plan = value?.paymentPlans?.[currentForm?.controls?.chosenPackageId?.value - 1] || null;
    }
    return plan;
  }

}
